import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ScheduledResource } from '../aims-scheduler/aims-scheduler.classes';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { HrEmployees, SchResources } from 'src/models';
import { SanDayAndItems } from '../aims-scheduler/aims-scheduler-calendarview.component';
import * as moment from 'moment-mini';
import { take } from 'rxjs/operators';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { AimsCommonPopupEditorData } from '@aims/common-components';
import { FormControl, NgForm } from '@angular/forms';

@Component({
  selector: 'aims-san',
  templateUrl: './san.component.html',
  styleUrls: ['./san.component.scss']
})
export class SanComponent implements OnInit {

  constructor(contentData: AimsCommonPopupEditorData,
    private transferHttp: TransferHttpService, public permissions: PermissionsService) {
    this.formGroup = contentData.formGroup;
    this.sanSDN = contentData.contentData.sdi;
  }

  @ViewChild('sanForm', { static: true }) sanForm: NgForm;

  public formGroup: any;
  sanSDN: SanDayAndItems;
  m = moment;

  emps = this.transferHttp.getCache<Array<HrEmployees>>('employeeDropdown');
  resourceValues = this.transferHttp.getSingle<Array<SchResources>>('Sch/GetResourcesForLookUp');
  siteValues = this.transferHttp.getSingle('Sch/GetScheduleAndTravelSites');

  printSAN(): string {
    return `/reporting/SanHeader/trdp/{"Date":"${this.sanSDN.day.format("YYYY-MM-DD")}","Site":"${this.sanSDN.items[0].siteId}"}`;
  }

  checkConfirmedArrival(item: ScheduledResource) {
    return item.confirmArrival;
  }

  checkConfirmedDeparture(item: ScheduledResource) {
    return item.confirmDeparture;
  }

  confirmArrival(day: moment.Moment, item: ScheduledResource) {
    let retVal = item;
    if (item.confirmArrival != true) {
      item.confirmArrival = true;
      item.notes = (item.notes == null) ? "Confirmed arrival on " + day.format("MM/DD/YY") : item.notes + ", Confirmed arrival on " + day.format("MM/DD/YY");
    }
    this.sanForm.form.markAsDirty();
    return retVal;
  }

  confirmDeparture(day: moment.Moment, item: ScheduledResource) {
    let retVal = item;
    if (item.confirmDeparture != true) {
      item.confirmDeparture = true;
      item.notes = (item.notes == null) ? "Confirmed departure on " + day.format("MM/DD/YY") : item.notes + ", Confirmed departure on " + day.format("MM/DD/YY");
    }
    this.sanForm.form.markAsDirty();
    return retVal;
  }

  actionRequiredArrival(day: moment.Moment, item: ScheduledResource) {
    let retVal = item;
    if (item.confirmArrival != false) {
      item.confirmArrival = false;
      item.notes = (item.notes == null) ? "Arrival action required on " + day.format("MM/DD/YY") : item.notes + ", arrival action required on " + day.format("MM/DD/YY");
    }
    this.sanForm.form.markAsDirty();
    return retVal;
  }

  actionRequiredDeparture(day: moment.Moment, item: ScheduledResource) {
    let retVal = item;
    if (item.confirmDeparture != false) {
      item.confirmDeparture = false;
      item.notes = (item.notes == null) ? "Departure action required on " + day.format("MM/DD/YY") : item.notes + ", departure action required on " + day.format("MM/DD/YY");
    }
    this.sanForm.form.markAsDirty();
    return retVal;
  }

  checkArrivalTravel(day: moment.Moment, item: ScheduledResource): boolean {
    let retVal = moment(item.start).isSame(day, 'day');
    return retVal;
  }

  checkDepartureTravel(day: moment.Moment, item: ScheduledResource): boolean {
    let retVal = moment(item.end).isSame(day, 'day');
    return retVal;
  }

  ngOnInit() {
    this.resourceValues.subscribe();
  }

}
